import { z } from 'zod';

// Media schemas
export const mediaSchema = z.object({
  id: z.string().uuid(),
  userId: z.string().uuid(),
  siteId: z.string().uuid().nullable(),
  url: z.string().url(),
  filename: z.string(),
  size: z.number().int().positive(),
  mimeType: z.string(),
  createdAt: z.string().datetime(),
});

// Type exports
export type Media = z.infer<typeof mediaSchema>;
